import { useCallback } from 'react';
import { Button, CalendarService, Dialog, RangeDatePicker, StructuredDate } from '@optimus-web/core';
import { OptimusTextKey, useLocalization } from '@optimus-web/localization';

interface DateRangeCalendarProps {
    allowOneDateRange?: boolean;
    calendarService: CalendarService;
    endDate?: StructuredDate;
    isDialogOpen: boolean;
    numberOfMonths?: number;
    onApply: () => void;
    onCancel: () => void;
    onRangeChange: (startDate: StructuredDate, endDate: StructuredDate) => void;
    startDate?: StructuredDate;
}

export const DateRangeCalendar = ({
    allowOneDateRange = true,
    calendarService,
    endDate,
    numberOfMonths,
    onApply,
    onCancel,
    isDialogOpen,
    onRangeChange,
    startDate,
}: DateRangeCalendarProps) => {
    const { t } = useLocalization();
    const getCalendarService = useCallback(() => calendarService, [calendarService]);

    return (
        <Dialog
            active={isDialogOpen}
            contentWithoutPadding
            footer={{
                primary: (
                    <Button onClick={onApply} variant="primary" type="submit">
                        {t(OptimusTextKey.Ok)}
                    </Button>
                ),
                secondary: (
                    <Button onClick={onCancel} variant="tertiary" type="button">
                        {t(OptimusTextKey.Cancel)}
                    </Button>
                ),
            }}
            noMaxWidth
        >
            <RangeDatePicker
                allowOneDateRange={allowOneDateRange}
                endDate={endDate}
                getCalendarService={getCalendarService}
                numberOfMonths={numberOfMonths}
                onRangeChange={onRangeChange}
                startDate={startDate}
            />
        </Dialog>
    );
};
